import React from 'react';
import { Navigate } from 'react-router-dom';
import { LazyPage } from '@hocs';
import { Routes } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var SettingsPage = LazyPage('settings', 'SettingsPage');
var LogPage = LazyPage('log', 'LogPage');
var RegistrarsPage = LazyPage('registrars', 'RegistrarsPage');
var OrganizationsPage = LazyPage('organizations', 'OrganizationsPage');
var AdminConsoleUsersPage = LazyPage('admin-console-users', 'AdminConsoleUsersPage');
var appPrivateRoutes = [{
  name: Routes.Main,
  path: Routes.Main,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.Users,
    replace: true
  }),
  index: false
}, {
  name: Routes.Settings,
  path: Routes.Settings,
  element: /*#__PURE__*/_jsx(SettingsPage, {}),
  index: false,
  inline: false
}, {
  name: Routes.Log,
  path: Routes.Log,
  element: /*#__PURE__*/_jsx(LogPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Registrars,
  path: Routes.Registrars,
  element: /*#__PURE__*/_jsx(RegistrarsPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Organizations,
  path: Routes.Organizations,
  element: /*#__PURE__*/_jsx(OrganizationsPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Users,
  path: Routes.Users,
  element: /*#__PURE__*/_jsx(AdminConsoleUsersPage, {}),
  index: false,
  inline: true
}];
export { appPrivateRoutes };